import { Fragment } from 'react';
import { useLocation } from 'react-router-dom';

import classes from './Layout.module.css';
import MainNavigation from './MainNavigation';

const Layout = (props) => {
  const location = useLocation();
  // Ne pas afficher MainNavigation sur les routes Landing (/) et MarketFlow (/marketflow) car elles ont leur propre Header
  const showMainNavigation = location.pathname !== '/' && location.pathname !== '/marketflow';

  return (
    <Fragment>
      {showMainNavigation && <MainNavigation />}
      <main className={classes.main}>{props.children}</main>
    </Fragment>
  );
};

export default Layout;